import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IEncounterNotes } from 'src/app/models/IEncounterNotes';
import { Observable } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { IEncounterData } from 'src/app/models/IEncounterData';
import { CopyEncounterData } from 'src/app/models/copyEncounterData';
import { IAddendum } from 'src/app/models/IOperativeReport';
import { configuration } from 'src/environments/environment';
import { IDXDetails, IManageCPTProcDx } from 'src/app/models/IDXDetails';

@Injectable({
  providedIn: 'root'
})
export class ProgressNotesService {

  constructor(private http: HttpClient) { }

  // Get all progress notes by encounter Id
  getProgressNotes(encounterId: string, userId: string): Observable<IEncounterNotes[]> {
    return this.http.get<IEncounterNotes[]>(
      `${configuration.clinicapiUrl + 'Encounter/ProgressNotes'}?encounterid=${encounterId}&&userid=${userId}`);
  }

  // Get all encounters by patient Id and encounter type
  getPastEncounters(patId: number, type: number, selectedlocIds: string): Observable<IEncounterData[]> {
    return this.http.get<IEncounterData[]>(
      `${configuration.clinicapiUrl + 'Encounter/PastEncounters'}?locationId=${sessionStorage.getItem("LocationId")}&&patId=${patId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&type=${type}&&selectedLocations=${selectedlocIds}`);
  }

  //  sign off the encounter
  PhySignoffEncounter(encounterData: IEncounterData): Observable<string> {
    return this.http.post<string>
      (`${configuration.apiUrl + 'Scheduler/PhySignoffEncounter'}?locationid=${Number(sessionStorage.getItem("LocationId"))}&&UserId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, encounterData, {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
  }
  PhycoSignoffEncounter(encounterData: IEncounterData): Observable<string> {
    return this.http.post<string>
      (`${configuration.apiUrl + 'Scheduler/PhycoSignoffEncounter'}?locationid=${Number(sessionStorage.getItem("LocationId"))}&&UserId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, encounterData, {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
  }

  signOffEncounter(encounterData: IEncounterData): Observable<string> {
    const physig = encounterData.physicianSignature;
    const supvprovidersig = encounterData.coSignedSignature;
    encounterData.coSignedSignature = null;
    encounterData.physicianSignature = null;
    const posteddata = {
      inputdata: JSON.stringify(encounterData),
      signature: physig,
      signature1: supvprovidersig
    }
    return this.http.post<string>
      (`${configuration.clinicapiUrl + 'Encounter/SignoffEncounter'}?UserId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, posteddata, {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
  }
  cosignOffEncounter(encounterData: IEncounterData): Observable<string> {
    const cophysig = encounterData.coSignedSignature;
    encounterData.coSignedSignature = null;
    const physig = encounterData.physicianSignature;
    encounterData.physicianSignature = null;
    const posteddata = {
      inputdata: JSON.stringify(encounterData),
      signature: cophysig,
      signature1: physig
    }
    return this.http.post<string>
      (`${configuration.clinicapiUrl + 'Encounter/coSignoffEncounter'}?UserId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, posteddata, {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
  }
  signOffOrderNoteEncounter(encounterData: IEncounterData): Observable<string> {
    return this.http.post<string>
      (`${configuration.clinicapiUrl + 'Encounter/SignoffOrdernotesEncounter'}?UserId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, encounterData, {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
  }

  //  claim status from Billing Application

  getclaimDetailsVisitNoteSignOff(encoounterId: string, categoryId: number, facilityId: number) {
    return this.http.get<String>(
      `${configuration.billingApiUrl + 'Claim/claimDetails'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&encounterId=${encoounterId}&&categoryId=${categoryId}&&serverPrefix=LOC&&facilityId=${sessionStorage.getItem("FacilityId")}`);
  }


  // Get encounter details by encounter Id
  getEncounter(encoounterId: string, type: number): Observable<IEncounterData> {
    return this.http.get<IEncounterData>
      (`${configuration.clinicapiUrl + 'Encounter/Encounter'}?encounterId=${encoounterId}&&categoryId=${type}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);

  }

  getOrderNoteEncounter(encoounterId: string, type: number): Observable<IEncounterData> {
    return this.http.get<IEncounterData>
      (`${configuration.clinicapiUrl + 'Encounter/getOrderNoteEncounter'}?encounterId=${encoounterId}&&categoryId=${type}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);

  }

  // Get provider signature by Id
  userSignatureById(providerId: string, securityCode: string): Observable<any> {
    return this.http.get<any>
      (`${configuration.apiUrl + 'Admin/UserSignatureById'}?userid=${providerId}&&securityCode=${securityCode}&&facility=${sessionStorage.getItem("FacilityId")}`);

  }

  // Get passing provider signature by Id
  userPassingSignatureById(providerId: string): Observable<any> {
    return this.http.get<any>
      (`${configuration.apiUrl + 'Admin/UserPassingSignatureById'}?userid=${providerId}&&facility=${sessionStorage.getItem("FacilityId")}`);

  }

  updateTranscrptionStatus(encounterId: string, categoryId: number): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/Transcription'}?encounterId=${encounterId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&categoryId=${categoryId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  updateorderNoteTranscrptionStatus(encounterId: string, categoryId: number): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/OrderNoteTranscription'}?encounterId=${encounterId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&categoryId=${categoryId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  //  Generate reports for particular encounter


  generateReports(encounterData: string, reportId: number, categoryId: number, ConsentMapID: number, IssignOff: boolean = true, isDefaultIntake: boolean = false): Observable<void> {
    const NoteReport_PenRequest = {
      locationid: Number(sessionStorage.getItem("LocationId")),
      encounterId: encounterData,
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      reportId: reportId,
      categoryId: categoryId,
      ConsentMapID: ConsentMapID,
      overWriteStatus: true,
      IssignOff: IssignOff,
      isDefaultIntake: isDefaultIntake,
    }
    return this.http.post<void>
      (`${configuration.apiUrl + 'Document/NoteReports'}`, NoteReport_PenRequest, {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
  }



  generateHnpReports(encounterData: string, reportname: string, categoryId: number): Observable<void> {
    const HNPNoteReport_PenRequest = {
      encounterId: encounterData,
      reportname: reportname,
      categoryId: categoryId,
      locationID: Number(sessionStorage.getItem("LocationId")),
      facilityId: sessionStorage.getItem("FacilityId"),
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      overWriteStatus: true
    }
    return this.http.post<void>
      (`${configuration.apiUrl + 'Document/HNPNoteReports'}`, HNPNoteReport_PenRequest, {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
  }


  DocumentCategory_NoteReports(reportId: number, doctype: string, DocLibId: number, patientId: number, locationID: number, EncId: string, AppId: String): Observable<void> {
    const DocLibNoteReport_PenRequest = {
      doctype: doctype,
      facilityId: sessionStorage.getItem("FacilityId"),
      patientId: patientId,
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      reportId: reportId,
      overWriteStatus: true,
      DocLibId: DocLibId,
      locationID: locationID,
      encounterId: EncId,
      appointmentId: AppId
    }
    return this.http.post<void>
      (`${configuration.apiUrl + 'Document/DocumentLibrary_NoteReports'}`, DocLibNoteReport_PenRequest, {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
  }



  // Get all in progress notes of encounters
  getInprogressNotes(patId: number, type: number, status: string, encounterId: string): Observable<IEncounterData[]> {
    return this.http.get<IEncounterData[]>(
      `${configuration.clinicapiUrl + 'Encounter/InpgoressNotes'}?facilityId=${sessionStorage.getItem("FacilityId")}&&patId=${patId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&type=${type}&&status=${status}&&encounterId=${encounterId}`);
  }

  // get notes by type
  getEncounterNotesType(encounterId: string, type: string) {
    return this.http.get<string>(
      `${configuration.clinicapiUrl + 'Encounter/NotesByTpe'}?encounterId=${encounterId}&&type=${type}`);

  }

  //copies encounter data to another encounter
  copyFromPastEncounter(encounterData: CopyEncounterData): Observable<string> {
    const postedData = {
      inputdata: JSON.stringify(encounterData)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/copyFromPastEncounter'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  //update Transcription status



  // Update Lock Status
  updateLockStatus(encounterId: string, isSignedOff: boolean, modified: string, type: number): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/UpdateLock'}?encounterId=${encounterId}&&isSignedOff=${isSignedOff}&&modifiedBy=${modified}&&type=${type}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  SaveAddendumbyEncounterId(AddendumInfo: IAddendum): Observable<IAddendum> {
    const posteddata = {
      inputdata: JSON.stringify(AddendumInfo)
    }
    return this.http.post<IAddendum>(`${configuration.clinicapiUrl + 'Encounter/SetAddendeumProgressNote'}`, posteddata, {
    });
  }
  getAddendumbyEncounterId(encId: string): Observable<IAddendum[]> {
    return this.http.get<IAddendum[]>(`${configuration.clinicapiUrl + 'Encounter/GetProgressNoteAddendumByEncId'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&locationId=${Number(sessionStorage.getItem("LocationId"))}`);
  }

  //ValidateSecurityCode

  // Get provider signature by Id
  ValidateSecurityCode(providerId: string, securityCode: string): Observable<string> {
    return this.http.get<string>
      (`${configuration.apiUrl + 'Admin/ValidateSecurityCode'}?userid=${providerId}&&securityCode=${securityCode}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }
  // get provider sign without password
  ValidateSecurityCodeWithoutPassword(providerId: string): Observable<string> {
    return this.http.get<string>
      (`${configuration.apiUrl + 'Admin/ValidateSecurityCodeWithoutPassword'}?userid=${providerId}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  getProceduresByEncId(encId: string): Observable<boolean> {
    return this.http.get<boolean>(
      `${configuration.clinicapiUrl + 'Encounter/SignOffProcedure'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  SignOffProcedureByEncounterList(encIds: string): Observable<boolean> {
    return this.http.get<boolean>(
      `${configuration.clinicapiUrl + 'Encounter/SignOffProcedureByEncounterList'}?encIds=${encIds}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  orNoteSignOff(encId: string): Observable<boolean> {
    return this.http.get<boolean>(
      `${configuration.clinicapiUrl + 'Encounter/SignOffORRecord'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  // ****** Save To Chart in Order Notes*******



  SaveToChartOrderNotesByEncounterId(encounterId: string): Observable<boolean> {
    const OrderNotetoChart_PenRequest = {
      encounterId: encounterId,
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<boolean>(
      `${configuration.apiUrl + 'Document/SaveOrderNote'}`, OrderNotetoChart_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  // ****** Get Dx by Encounter 
  getDXlistByEncId(encId: string): Observable<IDXDetails[]> {
    return this.http.get<IDXDetails[]>(
      `${configuration.clinicapiUrl + 'Encounter/GetDxByEncounter'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getAllDXlist(): Observable<IManageCPTProcDx[]> {
    return this.http.get<IManageCPTProcDx[]>(
      `${configuration.clinicapiUrl + 'Encounter/GetAllDxList'}`);
  }

  getAllProceduresByEncId(encId: string): Observable<any> {
    return this.http.get<any>(
      `${configuration.clinicapiUrl + 'Encounter/CheckAllProceduresSignOff'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  SignOffdashboardProcedureByEncounterList(encIds: string): Observable<boolean> {
    return this.http.get<boolean>(
      `${configuration.clinicapiUrl + 'Encounter/SignOffdashboardProcedureByEncounterList'}?encIds=${encIds}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getAlldashboardProceduresByEncId(encId: string): Observable<string[]> {
    return this.http.get<string[]>(
      `${configuration.clinicapiUrl + 'Encounter/CheckAlldashboardProceduresSignOff'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getAllorNoteProceduresByEncId(encId: string): Observable<string[]> {
    return this.http.get<string[]>(
      `${configuration.clinicapiUrl + 'Encounter/CheckAllorNoteProceduresSignOff'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  getAllProceduresByOrNoteEncId(encId: string): Observable<string[]> {
    return this.http.get<string[]>(
      `${configuration.clinicapiUrl + 'Encounter/CheckAllProceduresByORNoteSignOff'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  getAllORRecordProceduresByEncId(encId: string): Observable<boolean> {
    return this.http.get<boolean>(
      `${configuration.clinicapiUrl + 'Encounter/SignOffProcedureORNote'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  updateTranscrptionPostSurgicalStatus(encounterId: string, screendif: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/PostSurgicalTranscription'}?encounterId=${encounterId}&&screendif=${screendif}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Get provider SaveToChart signature by Id
  userSaveToChartSignatureById(providerId: string): Observable<any> {
    return this.http.get<any>
      (`${configuration.apiUrl + 'Admin/userSaveToChartSignatureById'}?userid=${providerId}&&facility=${sessionStorage.getItem("FacilityId")}`);

  }


  AutoMeasure_ProvideAccess(ISVDTSelected: string, ISAPISelected: string, RequestType: string): Observable<any> {
    const postedData1 = {
      LoginUser: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      EncounterID: (sessionStorage.getItem("encounterid")).toString(),
      Access_VDT: ISVDTSelected,
      Access_API: ISAPISelected,
      inputType: RequestType
    }
    const posteddata = {
      inputdata: JSON.stringify(postedData1)
    }
    return this.http.post<any>(`${configuration.clinicapiUrl + 'Encounter/AutoMeasure_ProvideAccess'}`, posteddata);

  }

  // Get Intake in progress notes of encounters
  getInprogressNotesIntake(patId: number, type: number, status: string, encounterId: string, moduleType: string, categoryId: any): Observable<IEncounterData[]> {
    return this.http.get<IEncounterData[]>(
      `${configuration.clinicapiUrl + 'Encounter/IntakeInpgoressNotes'}?facilityId=${sessionStorage.getItem("FacilityId")}&&patId=${patId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&type=${type}&&status=${status}&&encounterId=${encounterId}&&moduleType=${moduleType}&&categoryId=${categoryId}`);
  }

  //copies encounter data to another encounter
  copyFromPastEncounterIntake(oldEncounterId: string, NewEncounterId: string, catType: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/copyFromPastEncounterIntake'}?oldEncounterId=${oldEncounterId}&&NewEncounterId=${NewEncounterId}&&catType=${catType}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getCheckUserLockInfo(userId: string): any {
    if (!userId) {
      userId = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    }
    return this.http.get<any>(
      `${configuration.apiUrl + 'Activation/CheckUserLock'}?userid=${userId}`);
  }

  InsertClaimData(postdata: any): any {
    const posteddata = {
      inputdata: JSON.stringify(postdata)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Encounter/ClaimInfo'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
}
